module.exports = __webpack_public_path__ + "media/images/vouchers/algologie_vagues-df431e0d2b9461ab213540cf99479b79.png";